import Redispatcher from '../../services/redispatcher';
import { BIND_REDISPATCH_EVENT } from '../actions';

export default redispatcher => () => next => action => {
  if (Redispatcher.events[action.type]) {
    redispatcher && redispatcher.emit(action.type, action.payload);
  } else if (action.type === BIND_REDISPATCH_EVENT) {
    redispatcher && redispatcher.on(action.payload.eventName, action.payload.eventHandler);
  }
  return next(action);
};
